import React from 'react';
import Helmet from 'react-helmet';
import { useForm, ValidationError } from '@formspree/react';

const Contact = () => {
    
    const [state, handleSubmit] = useForm("myzjjngd");

    return (
        <div className="innerDiv">
            <Helmet>
                <title>Contact | Rafsan Bari</title>
                <meta name="description" content="Contact Rafsan Bari for any inquiries or project ideas." />
                <meta name="keywords" content="Rafsan Bari, contact, project ideas" />
            </Helmet>
            <div class="pagetitle"><h1>Reach out</h1></div>
            <div className="flexContainer">
                <div className="textContainer">
                    <h3>Let's Connect!</h3>
                    <p>Thanks for stopping by! If you're looking for a passionate Front-End Developer to help bring your digital vision to life, you're in the right spot. Don't hesitate to reach out with any questions or just to say hello.</p>
                </div>

                {state.succeeded ? (
                    <div className="success-message alert alert-success">
                        <p>Thanks for reaching out! I'll get back to you as soon as I can.</p>
                    </div>
                ) : (
                <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <input type="text" name="name" placeholder="Name" className="form-control"/>
                        </div>
                        <div className="mb-3">
                            <input type="email" name="email" placeholder="Email" className="form-control"/>
                            <ValidationError prefix="Email" field="email" errors={state.errors} />
                        </div>
                        <div className="mb-3">
                            <textarea name="message" placeholder="Message" rows="4" cols="50" className="form-control" />
                            <ValidationError prefix="Message" field="message" errors={state.errors} />
                        </div>
                        <button type="submit" disabled={state.submitting} className="btn buttonglow">Submit</button>
                    </form>
                )}
            </div>
        </div>
    )
}

export default Contact;